import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAstronaut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 8C2 7.44772 2.44772 7 3 7H21C21.5523 7 22 7.44772 22 8V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V8ZM4 9V18H20V9H4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H20V8C20 8.55228 19.5523 9 19 9C18.4477 9 18 8.55228 18 8V6H6V8C6 8.55228 5.55228 9 5 9C4.44772 9 4 8.55228 4 8V6H3C2.44772 6 2 5.55228 2 5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 19V9H8V19H6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 19V9H18V19H16Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.60858 8.01005C10.1553 7.93195 10.6618 8.31184 10.7399 8.85858L11.6173 15H12.3827L13.26 8.85858C13.3382 8.31184 13.8447 7.93195 14.3914 8.01005C14.9382 8.08816 15.3181 8.59469 15.2399 9.14142L14.2399 16.1414C14.1696 16.6341 13.7477 17 13.25 17H10.75C10.2523 17 9.83043 16.6341 9.76005 16.1414L8.76005 9.14142C8.68195 8.59469 9.06184 8.08816 9.60858 8.01005Z",
			fill: "currentColor"
		})
	]
});
export default SvgAstronaut;
